/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useNavigate } from "react-router-dom";

const CancelChefPK = () => {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId"); 

  return (
    <section className="container-fluid">
      <div className="overlay"></div>
      <div className="drawer small add-dish">
        <div className="alert-wrap">
          <img
            className="ico mb-2"
            src="/assets/images/alert-warning-ico.svg"
            alt="cancel"
          />
         
          <p className="mid-gray mb-2 mt-3 text-center ps-3">
            <small>
              The payment was unexpectedly canceled, indicating that the user
              chose to terminate the transaction before completion. This may be
              due to various reasons, including payment method issues or personal
              preferences.
            </small>
          </p>
          <button
            className="btn btn-cancel rounded-5 mt-3 btn-outline-primary mb-3"
            onClick={() => navigate(`/pk/subscriptions`)} 
          >
            Back to Home
          </button>
        </div>
      </div>
    </section>
  );
};

export default CancelChefPK;
